import React from "react";
import { compose, withProps } from "recompose";
import WysiwygV2 from "theme/modules/WysiwygV2";
import Loadable from "theme/components/helpers/Loadable";
import Breadcrumb from "theme/components/organisms/Breadcrumb";
import { H1 } from "theme/components/atoms/Typography/Heading";
import CmsPageSeo from "theme/modules/CmsPage/CmsPageSeo";
import withTrackPage from "theme/modules/Analytics/withTrackPage";
import { withApollo } from "react-apollo";
import { trackGlobalPage } from "../../components/helpers/AnalyticsV4/TrackAnlyticsV4";

const CmsPage = (props) => {
  return (
    <div itemScope itemType="http://schema.org/WebPage">
      <CmsPageSeo page={props.cms} />
      <Breadcrumb paths={[{ name: props.cms.title }]} />
      {props.cms.content_heading && (
        <H1 itemProp="headline">{props.cms.content_heading}</H1>
      )}
      <article itemProp="mainContentOfPage" className="cms-page">
        <WysiwygV2 content={props.cms.contentWysiwyg} />
      </article>
    </div>
  );
};

export default compose(
  withApollo,
  Loadable((props) => !props.loading, true),
  withProps((props) => {
    if (
      props.client &&
      (props.cms?.isLandingWomen ||
        props.cms?.isLandingMen ||
        props.cms?.isLandingKid)
    ) {
      props.client.resetStore();
    }
  }),
  withTrackPage((props) => props.cms.title),
  trackGlobalPage()
)(CmsPage);
